<template>
  <div v-if="visible" class="cef-card mt-4">
    <button class="cef-header" type="button" @click="isOpen = !isOpen">
      <h4 class="cef-header__title">
        <i class="uil-table"></i>
        {{ $t('collectionDetail.collection_details') }}
      </h4>
      <i :class="isOpen ? 'uil-angle-up' : 'uil-angle-down'" class="cef-header__arrow"></i>
    </button>

    <div v-show="isOpen" class="cef-body">
      <div class="mb-2">
        <label>{{ $t('collectionDetail.name') }}</label>
        <input v-model="form.name" class="uk-input border-0 bg-white text-primary" type="text"/>
      </div>
      <div class="mb-2">
        <label>{{ $t('collectionDetail.description') }}</label>
        <textarea v-model="form.description" class="uk-textarea border-0 bg-white text-primary"></textarea>
      </div>
      <div class="mb-2">
        <label>{{ $t('collectionDetail.tags') }}</label>
        <multiselect v-model="hashtags" :multiple="true" :openDirection="'bottom'" :options="hashtagsOptions"
                     :placeholder="$t('general.add_tag')" :tag-placeholder="$t('general.add_tag')"
                     :taggable="true" :appendToBody="true" deselectGroupLabel="Grubun seçimini kaldırmak için enter'a basın"
                     deselectLabel="Kaldırmak için enter'a basın"
                     label="name" selectGroupLabel="Grup seçmek için enter'a basın"
                     selectLabel="Seçmek için enter'a basın" selectedLabel="Seçilmiş" track-by="id"
                     @change="(val) => { hashtags = val }" @tag="addTag"/>
      </div>

      <div class="d-flex justify-content-between align-items-center mt-4">
        <div class="d-flex justify-content-start align-items-center">
          <span class="mr-2">{{ $t('collectionDetail.is_public') }}</span>
          <label class="uk-switch mb-0" for="is_public_check">
            <input id="is_public_check" v-model="form.is_public" type="checkbox" @change="changePublic">
            <div class="uk-switch-slider"></div>
          </label>
        </div>

        <button class="btn btn-primary" @click="saveDetail">
          <i class="uil-check-circle" style="font-size: 120%;"></i> {{ $t('general.save') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import ApiService from "@/core/services/api.service";
import { GET_ITEMS } from "@/core/services/store/REST.module";

export default {
  name: "CollectionEditForm",
  components: { Multiselect },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    collectionId: {
      type: [String, Number],
      required: true
    },
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isOpen: false,
      form: {
        name: this.item.name || '',
        description: this.item.description || '',
        is_public: this.item.is_public || false
      },
      hashtags: [],
      hashtagsOptions: [],
      isSaving: false
    };
  },
  mounted() {
    this.loadTags();
  },
  watch: {
    item: {
      handler(val) {
        this.form.name = val.name || '';
        this.form.description = val.description || '';
        this.form.is_public = val.is_public || false;
        if (this.isSaving) return;
        if (val.tags) {
          try {
            if (Array.isArray(val.tags)) {
              this.hashtags = val.tags;
            } else {
              const parsed = JSON.parse(val.tags);
              this.hashtags = Array.isArray(parsed) ? parsed : [];
            }
          } catch (e) {
            this.hashtags = [];
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    loadTags() {
      this.$store.dispatch(GET_ITEMS, {
        url: "api/collection-tags",
        acceptPromise: true
      }).then((result) => {
        if (result.status && result.data) {
          // String array'i object array'e dönüştür
          this.hashtagsOptions = result.data.map(tag => ({
            name: tag,
            id: tag
          }));
        }
      });
    },
    addTag(newTag, id = null) {
      var regexp = /[<>{}();\/\\]/;
      if (regexp.test(newTag) || newTag.trim().length === 0) return false;
      const tag = {
        name: newTag,
        id: id ?? 'custom_' + newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.hashtagsOptions.push(tag);
      this.hashtags.push(tag);
    },
    changePublic() {
      ApiService.post("api/collection/change-public/" + this.collectionId, {
        is_public: this.form.is_public ? 1 : 0
      });
    },
    saveDetail() {
      let form = new FormData();
      form.append("name", this.form.name);
      form.append("description", this.form.description);
      form.append("is_public", this.form.is_public === true ? 1 : 0);
      form.append("_method", 'PUT');

      this.createFormDataForList(form, 'tags', this.hashtags);

      this.isSaving = true;
      ApiService.post("api/collection/" + this.collectionId, form)
        .then((response) => {
          this.$emit("saved", response.data);
          this.$nextTick(() => {
            this.isSaving = false;
          });
        })
        .catch(() => {
          this.isSaving = false;
          this.$emit("error");
        });
    }
  }
};
</script>

<style scoped>
/* ═══════════════════════════════════════
   GENEL (Web + Mobil)
   ═══════════════════════════════════════ */

/* Kart */
.cef-card {
  background: #fff;
  border: 1px solid #e8e9ec;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

/* Header: tıklanabilir aç-kapa */
.cef-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.cef-header:focus {
  outline: none;
}

.cef-header:focus-visible {
  outline: none;
}

.cef-header:active {
  background: #f5f6fa;
}

.cef-header__title {
  font-size: 17px;
  font-weight: 600;
  line-height: 1.4;
  color: #222;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
}

.cef-header__arrow {
  font-size: 22px;
  color: #999;
  flex-shrink: 0;
}

/* Body: form içeriği */
.cef-body {
  padding: 0 16px 16px;
}

/* Label */
.cef-body label {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  margin-bottom: 4px;
  display: block;
  color: #555;
}

/* Input */
.cef-body .uk-input {
  min-height: 48px;
  border-radius: 8px;
  font-size: 16px;
  line-height: 1.4;
  padding: 0 16px;
  background: #f8f9fb !important;
  border: 1px solid #dcdee3 !important;
  color: #333 !important;
}

.cef-body .uk-input:focus {
  border-color: #666CFF !important;
  background: #fff !important;
}

/* Textarea */
.cef-body .uk-textarea {
  min-height: 96px;
  border-radius: 8px;
  font-size: 16px;
  line-height: 1.5;
  padding: 12px 16px;
  background: #f8f9fb !important;
  border: 1px solid #dcdee3 !important;
  color: #333 !important;
}

.cef-body .uk-textarea:focus {
  border-color: #666CFF !important;
  background: #fff !important;
}

/* Save buton: desktop 36px */
.cef-body .btn {
  min-height: 36px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 16px;
  -webkit-tap-highlight-color: transparent;
}

.cef-body .btn:active {
  transform: scale(0.98);
  opacity: 0.85;
}

.cef-body .btn:disabled {
  opacity: 0.5;
  pointer-events: none;
}

/* ═══════════════════════════════════════
   MOBİL (≤768px)
   ═══════════════════════════════════════ */
@media (max-width: 768px) {
  /* Header: touch target */
  .cef-header {
    min-height: 56px;
  }

  /* Form alanları arası */
  .cef-body .mb-2 {
    margin-bottom: 16px !important;
  }

  /* Switch text */
  .cef-body .d-flex span {
    font-size: 16px;
    line-height: 1.4;
    color: #333;
  }

  /* Switch touch */
  .cef-body .uk-switch {
    padding: 5px 0;
  }

  /* Alt aksiyonlar dikey */
  .cef-body .d-flex.justify-content-between {
    flex-direction: column;
    gap: 16px;
  }

  /* Save buton: full-width, 48px */
  .cef-body .btn {
    width: 100%;
    min-height: 48px;
    font-size: 16px;
    padding: 0 24px;
  }

  /* Multiselect */
  .cef-body .multiselect {
    min-height: 48px;
    border-radius: 8px;
    font-size: 16px;
  }

  .cef-body .multiselect__tag {
    border-radius: 20px;
    font-size: 14px;
    padding: 4px 24px 4px 8px;
    min-height: 32px;
    display: inline-flex;
    align-items: center;
  }

  .cef-body .multiselect__input {
    min-height: 44px;
    font-size: 16px;
  }

  .cef-body .multiselect__option {
    min-height: 48px;
    font-size: 16px;
    padding: 12px 16px;
  }

  .cef-body .multiselect__content-wrapper {
    max-height: 200px !important;
    overflow-y: auto !important;
  }
}

/* Multiselect dropdown için genel stil */
.multiselect .multiselect__content-wrapper {
  max-height: 200px !important;
  overflow-y: auto !important;
  z-index: 99999999 !important;
  position: absolute !important;
}

.cef-card {
  overflow: visible !important;
}

.cef-body {
  overflow: visible !important;
}
</style>
